<template>
  <div class="view-wrapper this-wrapper view-wrapper-master-overlay">
    <div class="view view-master-full">
      <v-toolbar class="my-bar">
        <v-dialog
          v-if="rightFilter('w')"
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          scrollable
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="add">
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <v-card v-if="dialog">
            <v-toolbar class="my-bar">
              <v-toolbar-title>{{
                "Добавление строк счета: ".concat(
                vm.item.organization.fullName,
                ", № ",
                vm.item.number,
                " от ",
                vm.item.postingDate4List
                )
                }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="dialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <ServiceAdd :vm="this"></ServiceAdd>
          </v-card>
        </v-dialog>
        <v-btn
          v-if="rightFilter('d')"
          icon
          :disabled="!editItem"
          @click="dialogDelete = true"
        >
          <v-icon>remove</v-icon>
        </v-btn>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline"
            >Вы точно хотите удалить услугу?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogDelete = false">Отмена</v-btn>
              <v-btn color="primary" text @click="deleteConfirm">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-spacer />
        <ServiceHistory :item="editItem"></ServiceHistory>
        <v-text-field
          v-model="amount"
          label="Итого"
          hide-details
          outlined
          dense
          readonly
          style="max-width: 168px; margin: 0 2px"
        ></v-text-field>
        <v-text-field
          v-model="discountedAmount"
          label="Итого со скидкой"
          hide-details
          outlined
          dense
          readonly
          style="max-width: 168px; margin: 0 2px"
        ></v-text-field>
        <v-btn icon color="primary" :loading="loading" @click="exp">
          <v-icon>cloud_download</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        :single-select="true"
        item-key="id"
        show-select
        hide-default-footer
        :loading="loading"
        loading-text="Загрузка... Пожалуйста подождите"
        fixed-header
        :item-class="itemColor"
        @click:row="rowClick"
      >
        <template v-slot:item.stateKey="{ item }">
          <v-icon v-if="item.stateKey === 'E'" color="green">done</v-icon>
          <v-icon v-else-if="item.stateKey === 'R'" color="blue"
          >arrow_right</v-icon
          >
          <v-icon v-else color="orange">arrow_left</v-icon>
        </template>
      </v-data-table>
    </div>
    <div v-if="editItem" class="view-detail-overlay">
      <v-toolbar class="my-bar">
<!--        <v-btn
          v-if="rightFilter('w')"
          icon
          :disabled="!serviceDetail || !serviceDetail.valid"
          @click="save"
        >
          <v-icon>save</v-icon>
        </v-btn>-->
        <SaveButton
        :additional-rules="!serviceDetail || !serviceDetail.valid"
        :handler="save"
        >

        </SaveButton>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <ServiceDetail :vm="this"></ServiceDetail>
    </div>
    <CheckLimit :vm="this"></CheckLimit>
  </div>
</template>

<script>
  import fetch from "@/utils/fetch";
  import vm2js from "@/utils/vm2js";
  import js2vm from "@/utils/js2vm";
  import ctx from "@/ctx";
  import dateLocalFilter from "../../filters/dateLocal.filter";
  import dateIsoFilter from "../../filters/dateIso.filter";
  import ServiceDetail from "./ServiceDetail";
  import ServiceAdd from "./ServiceAdd";
  import moment from "moment";
  import CheckLimit from "../balance/Check";
  import rightFilter from "../../filters/right.filter";
  import ServiceHistory from "./ServiceHistory";
  import round2hunds from "../../utils/round2hunds";
  import SaveButton from "@/components/ButtonFacade";

  const extractServiceFromRow = function(d) {
    const rawService = d.service;
    const nested =
      rawService != null && typeof rawService === "object" ? rawService : null;
    const primitiveId =
      rawService != null &&
      typeof rawService !== "object" &&
      !Number.isNaN(Number(rawService))
        ? rawService
        : null;
    const primitiveName =
      rawService != null &&
      typeof rawService === "string" &&
      Number.isNaN(Number(rawService))
        ? rawService
        : null;

    const id =
      d.serviceId != null
        ? d.serviceId
        : primitiveId != null
          ? primitiveId
          : nested && nested.id;

    const name =
      d.serviceName ||
      d.serviceString ||
      primitiveName ||
      (nested &&
        (nested.name ||
          nested.serviceName ||
          nested.fullName ||
          nested.serviceString));

    return { id, name };
  };

  let Item = function(d, categoryLookup, serviceLookup = {}) {
    const getCategory = id => {
      if (id == null || id === "") return null;
      if (categoryLookup) {
        return categoryLookup[id] || categoryLookup[String(id)] || null;
      }
      return ctx.src.categories.get(id) || null;
    };

    const getService = id => {
      if (id == null || id === "") return null;
      const fromLookup = serviceLookup[id] || serviceLookup[String(id)];
      if (fromLookup) return fromLookup;
      return ctx.src.services.get(id) || null;
    };

    const { id: apiServiceId, name: apiServiceName } = extractServiceFromRow(d);
    if (d.serviceId == null && apiServiceId != null) {
      d.serviceId = apiServiceId;
    }

    let self = this;
    d.organization = d.organizationId;
    d.doctor = d.doctorId;
    d.diagnosis = d.diagnosisId;
    d.service = d.serviceId;
    d.serviceCategory = d.serviceCategoryId;
    d.visitDate4List = d.visitDate;
    d.postingDate4List = d.postingDate;

    d.diagnosisExt = d.diagnosisExt ? d.diagnosisExt : "";
    self.insured = d.insured;

    self.organization2vm = function(val) {
      if (!val) return {};
      return ctx.src.org.first(val);
    };
    self.doctor2vm = function(val) {
      if (!val) return {};
      return ctx.src.doctors.get(val);
    };

    self.diagnosis2vm = function(val) {
      if (!val) return {};
      return ctx.src.diagnosis.get(val) || {};
    };

    self.visitDate4List2vm = function(val) {
      return dateLocalFilter(val);
    };
    self.postingDate4List2vm = function(val) {
      return dateLocalFilter(val);
    };
    self.visitDate2vm = function(val) {
      return dateIsoFilter(val);
    };
    self.postingDate2vm = function(val) {
      return dateIsoFilter(val);
    };

    self.service2vm = function(val) {
      const serviceId = val != null ? val : apiServiceId;
      if (serviceId == null) return {};
      const service = getService(serviceId);
      if (service) return service;
      if (apiServiceName) return { id: serviceId, name: apiServiceName };
      return {};
    };
    self.serviceCategory2vm = function(val) {
      if (val == null || val === "") return {};
      return getCategory(val) || {};
    };

    js2vm(self, d);

    const categoryId = self.serviceCategoryId != null ? self.serviceCategoryId : d.serviceCategoryId;
    if (categoryId != null) {
      self.serviceCategoryId = categoryId;
      const category = getCategory(categoryId);
      if (category) {
        self.serviceCategory = category;
      }
    }
    self.serviceCategoryName4List =
      d.serviceCategoryName ||
      d.serviceCategoryName4List ||
      (self.serviceCategory && self.serviceCategory.name) ||
      "";

    const serviceName =
      (self.service && self.service.name) ||
      apiServiceName ||
      (serviceLookup[self.serviceId] && serviceLookup[self.serviceId].name) ||
      (serviceLookup[String(self.serviceId)] &&
        serviceLookup[String(self.serviceId)].name) ||
      "";
    self.serviceName4List = serviceName;
    if ((!self.service || !self.service.name) && serviceName) {
      self.service = { id: self.serviceId || apiServiceId, name: serviceName };
    }
  };

  export default {
    props: {
      vm: Object
    },
    data: () => ({
      ctx,
      rightFilter,
      serviceDetail: undefined,
      currentPage: 0,
      totalPages: 0,
      loading: false,
      selected: [],
      headers: [
        { text: "", value: "stateKey" },

        {
          text: "Номер",
          sortable: false,
          value: "index"
        },
        {
          text: "Застрахованный",
          value: "insuredLabel"
        },
        { text: "Доктор", value: "doctor.fullName" },
        { text: "Дата введения", sortable: false, value: "postingDate4List" },
        { text: "Дата обращения", sortable: true, value: "visitDate4List" },
        { text: "Диагноз", sortable: true, value: "diagnosis.label" },
        { text: "Услуга", sortable: true, value: "serviceName4List" },
        { text: "Категория", sortable: true, value: "serviceCategoryName4List" },
        { text: "Кол-во", sortable: true, value: "quantity" },
        { text: "% Скидка", sortable: true, value: "discountPercent" },
        { text: "Сумма", sortable: true, value: "amount" },
        { text: "Со скидкой", sortable: true, value: "discountedAmount" },
        { text: "Контрольный номер", sortable: false, value: "checkNumber" }
      ],
      items: [],
      item: undefined,
      dialog: false,
      dialogDelete: false,
      editItem: undefined,
      searchText: undefined,
      categoryLookup: null,
      serviceLookup: null
    }),
    watch: {
      "vm.item": function(val) {
        this.selected = [];
        this.items = [];
        if (val) {
          this.fetchItems();
        }
      },
      selected: function(val) {
        if (val.length === 0) this.editItem = undefined;
        else {
          this.editItem = new Item(vm2js(val[0]), this.categoryLookup, this.serviceLookup);
        }
      }
    },
    methods: {
      itemColor(item) {
        if (!item.insured || !item.insured.startDate || !item.insured.endDate)
          return "";
        if (
          moment(item.visitDate) < moment(item.insured.startDate) ||
          moment(item.visitDate) > moment(item.insured.endDate)
        )
          return "item-red";
        return "";
      },
      add() {
        this.close();
        this.dialog = true;
      },
      async deleteConfirm() {
        const res = await fetch.post(
          "/api/accounting/invoices/delete-service?id=" + this.editItem.id
        );
        if (res) {
          const index = this.items.indexOf(this.selected[0]);
          this.items.splice(index, 1);
          this.selected = [];
          this.dialogDelete = false;
        }
      },
      async save() {
        let arr = [];
        let item = vm2js(this.editItem);
        item.id = undefined;
        item.discountedAmount =
          item.discountedAmount - this.selected[0].discountedAmount;
        item.quantity = item.quantity - this.selected[0].quantity;
        arr.push(item);

        this.limitCheck.setItem(item);

        this.limitCheck.check(
          item.insuredId,
          item.serviceCategoryId,
          item.discountedAmount,
          item.quantity,
          item.id
        )
        const res = await fetch.post(
          "/api/accounting/invoices/save-service",
          vm2js(this.editItem)
        );
        if (res) {
          this.fetchItems();
          this.close();
        }
        this.sortByCardPeriod();
      },
      close() {
        this.selected = [];
      },
      async fetchItems() {
        this.items = [];

        if (!this.vm.item.id) return;
        this.loading = true;
        try {
          await this.getItems();
          this.sortByCardPeriod();
        } finally {
          this.loading = false;
        }
      },
      async ensureCategoryLookup() {
        if (this.categoryLookup) return this.categoryLookup;

        const lookup = {};
        const add = c => {
          if (!c || c.id == null) return;
          lookup[c.id] = c;
          lookup[String(c.id)] = c;
        };
        (ctx.src.categories.items || []).forEach(add);

        const allCategories = await fetch.get(
          "/api/accounting/services/get-categories?includeDeleted=true"
        );
        if (Array.isArray(allCategories)) {
          allCategories.forEach(add);
        }

        this.categoryLookup = lookup;
        return lookup;
      },
      async ensureServiceLookup(rows) {
        await ctx.src.services.init();

        const lookup = {};
        const add = service => {
          if (!service || service.id == null) return;
          const existing = lookup[service.id] || lookup[String(service.id)];
          if (existing && existing.name && !service.name) return;
          lookup[service.id] = service;
          lookup[String(service.id)] = service;
        };
        (ctx.src.services.items || []).forEach(add);

        // Услуги вне общего справочника (неактивные/программные) —
        // добираем через get-active-services только для строк без имени.
        const insuredIdsNeedingLookup = [
          ...new Set(
            (rows || [])
              .filter(r => {
                const serviceId =
                  r.serviceId != null
                    ? r.serviceId
                    : r.service && typeof r.service === "object"
                      ? r.service.id
                      : null;
                if (serviceId == null) return false;
                if (r.serviceName || r.serviceString) return false;
                if (
                  typeof r.service === "string" &&
                  Number.isNaN(Number(r.service))
                ) {
                  return false;
                }
                const found = lookup[serviceId] || lookup[String(serviceId)];
                if (found && found.name) return false;
                return r.insuredId != null;
              })
              .map(r => r.insuredId)
          )
        ];

        if (insuredIdsNeedingLookup.length) {
          await Promise.all(
            insuredIdsNeedingLookup.map(insuredId =>
              fetch
                .get(
                  "/api/accounting/services/get-active-services?insuredId=" +
                    insuredId
                )
                .then(activeServices => (activeServices || []).forEach(add))
                .catch(() => {})
            )
          );
        }

        return lookup;
      },
      async getItems() {
        const categoryLookup = await this.ensureCategoryLookup();

        let res = await fetch.get(
          "/api/accounting/invoices/get-all-services-by-invoice?invoiceId=" +
          this.vm.item.id
        );

        const serviceLookup = await this.ensureServiceLookup(res);
        this.serviceLookup = serviceLookup;

        if (res) {

          res.forEach(r => {
            this.items.push(new Item(r, categoryLookup, serviceLookup));
          });
        }


        if (res.first) {
          return res.totalPages;
        }
        this.sortByCardPeriod();
      },
      rowClick(obj, row) {
        if (!row.isSelected) row.select(obj);
        else this.selected = [];
      },
      async exp() {
        this.loading = true;
        try {
          await this.vm.exp();
        } finally {
          this.loading = false;
        }
      },
      sortByCardPeriod() {
        this.items = this.items.sort((a, b) => {
          return (moment(a.visitDate).isBefore(a.insured.startDate) || moment(a.visitDate).isAfter(a.insured.endDate)) ? -1 : !!b;
        })
      }
    },
    computed: {
      amount: function() {
        let sum = 0;
        this.items.forEach(i => {
          sum = round2hunds(sum + i.amount);
        });
        return sum;
      },
      discountedAmount: function() {
        let sum = 0;
        this.items.forEach(i => {
          sum = round2hunds(sum + i.discountedAmount);

        });

        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.vm.item.amount = sum;
        return sum;
      }
    },
    mounted() {
      this.vm.serviceList = this;

      this.fetchItems();


    },
    components: {
      SaveButton,
      ServiceAdd,
      ServiceDetail,
      CheckLimit,
      ServiceHistory
    }
  };
</script>

<style lang="scss" scoped>
  .this-wrapper {
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .this-wrapper::v-deep .v-data-table__wrapper {
    > table {
      counter-reset: section;
      tbody tr td:nth-child(3)::before {
        counter-increment: section;
        content: counter(section);
      }
    }
  }
</style>
